"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var satu_cookie_helper_1 = __importDefault(require("./satu-cookie-helper"));
var HTTP_STATUS_OK = 200;
var FeatureFlagLoader = /** @class */ (function () {
    function FeatureFlagLoader(options) {
        this.cache = {};
        this.endpoint = options.endpoint;
        this.satuId = satu_cookie_helper_1.default.getSatuId();
    }
    /**
     * Load feature flags from API and cache them
     */
    FeatureFlagLoader.prototype.loadFeatureFlags = function (evidences, filter) {
        if (filter === void 0) { filter = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var key, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        key = this.getEvidencesKey(evidences);
                        if (!!(key in this.cache)) return [3 /*break*/, 2];
                        _a = this.cache;
                        _b = key;
                        _c = this.parseFeatureFlags;
                        return [4 /*yield*/, this.fetchFeatureFlags(evidences, filter)];
                    case 1:
                        _a[_b] = _c.apply(this, [_d.sent()]);
                        _d.label = 2;
                    case 2: return [2 /*return*/, this.cache[key]];
                }
            });
        });
    };
    /**
     * Reset loader for new customer
     */
    FeatureFlagLoader.prototype.reset = function (satuId) {
        if (satu_cookie_helper_1.default.getSatuId() !== satuId) {
            satu_cookie_helper_1.default.setSatuId(satuId);
        }
        if (satuId !== this.satuId) {
            this.satuId = satuId;
            this.cache = {};
            return true;
        }
        return false;
    };
    /**
     * Internal method
     *
     * Create unique key for evidences
     * Key is used for caching
     */
    FeatureFlagLoader.prototype.getEvidencesKey = function (evidences) {
        evidences.sort(function (a, b) {
            if (a.name > b.name)
                return -1;
            if (a.name < b.name)
                return 1;
            return 0;
        });
        return btoa(JSON.stringify(evidences));
    };
    /**
     * Internal method
     *
     * Send request to API
     */
    FeatureFlagLoader.prototype.fetchFeatureFlags = function (evidences, filter) {
        return __awaiter(this, void 0, void 0, function () {
            var response, json;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.endpoint, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: 'application/vnd.api+json',
                            },
                            body: JSON.stringify({
                                identifiers: {
                                    satu: this.satuId,
                                },
                                evidences: evidences,
                                filters: {
                                    'feature_flags': filter.features,
                                    'test_names': filter.tests,
                                },
                            }),
                        })];
                    case 1:
                        response = _a.sent();
                        if (response.status !== HTTP_STATUS_OK) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        json = _a.sent();
                        return [2 /*return*/, json.data || []];
                }
            });
        });
    };
    /**
     * Internal method
     *
     * Convert API response to FeatureFlag[]
     */
    FeatureFlagLoader.prototype.parseFeatureFlags = function (responseItems) {
        var _this = this;
        return responseItems.map(function (item) {
            var ff = {
                name: item.name,
                value: _this.parseFeatureFlagValue(item.value),
            };
            if (item.split_result) {
                ff.splitResult = {
                    segmentId: item.split_result.segment_id,
                    testGroup: item.split_result.test_group,
                    testName: item.split_result.test_name,
                };
            }
            return ff;
        });
    };
    FeatureFlagLoader.prototype.parseFeatureFlagValue = function (value) {
        var trimmedValue = value.trim();
        if (value === 'true')
            return true;
        if (value === 'false')
            return false;
        if (trimmedValue !== '' && !Number.isNaN(+trimmedValue))
            return +trimmedValue;
        return trimmedValue;
    };
    return FeatureFlagLoader;
}());
exports.default = FeatureFlagLoader;
//# sourceMappingURL=feature-flag-loader.js.map